/**
 * Props for image slot (subset of Course API type)
 *
 * @remarks
 *
 * @see `browse/types/course`
 */

/**
 * Converts Course API fields to `CourseCard` image props.
 *
 * @remarks
 *
 * @see `browse/types/course`
 */
export const imagePropsFrom = _ref => {
  let {
    course
  } = _ref;
  return {
    srcSmallSquare: course.image_50x50,
    srcSmallSquare2x: course.image_100x100,
    srcDefault: course.image_240x135,
    srcDefault2x: course.image_480x270
  };
};
//# sourceMappingURL=image.js.map